import React from 'react';
import { Link } from 'react-router-dom';
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Container from 'react-bootstrap/Container';
//images
import inovadora26 from '../../../assets/images/certifications/inovadora26.png';
import logoInovaria from '../../../assets/images/certifications/logo-inovaria.svg';
import logo9001 from '../../../assets/images/certifications/logo-iso9001.svg';
import logo27001 from '../../../assets/images/certifications/logo-iso27001.svg';
import pme from '../../../assets/images/certifications/logo-PME-25.svg';
//files
import pdf9001 from '../../../assets/files/ISO-9001.pdf';
import pdf27001 from '../../../assets/files/ISO-27001.pdf';


const certifications = props => (
    <section
        id="homepage-section10"
        className="my">
        <Container>
            <div className="certifications-container">
                <div className="certifications">
                    <div className="d-flex">
                        <div className="certification inovadora">
                            <img src={inovadora26} alt="Logo Inovadora" />
                        </div>
                        <div className="certification">
                            <img src={logoInovaria} alt="Logo Inovaria" />
                        </div>
                    </div>
                    <div className="d-flex">
                        <div className="certification small">
                            <img src={pme} alt="PME Líder 2021" />
                        </div>
                        <div className="certification small">
                            <Link to={pdf9001} target="blank">
                                <img src={logo9001} alt="Empresa certificada ISO9001" />
                            </Link>
                        </div>
                        <div className="certification small">
                            <Link to={pdf27001} target="blank">
                                <img src={logo27001} alt="Empresa certificada ISO27001" />
                            </Link>
                        </div>
                    </div>

                </div>
            </div>
        </Container>
    </section>
)

export default certifications;
